<div
    provideParentForm
    class="license-quota-config"
>
    <h6 class="full-modal__section-header">
        {{ l10nKeys.licenseQuotaLabel | vtranslate }}
    </h6>

    <div class="full-modal-config__form-control-row license-quota-config__no-margin">
        <div class="full-modal-config__form-control">
            <avi-input-container noMarginTop>
                <label
                    aviLabelWithTooltip
                    objectType="QuotaConfig"
                    fieldName="reservation"
                    for="license-quota-reservation"
                >
                    {{ l10nKeys.licenseReservationInputLabel | vtranslate }}
                </label>
                <input
                    clrInput
                    id="license-quota-reservation"
                    name="license-quota-reservation"
                    type="number"
                    placeholder="{{ l10nKeys.licenseReservationInputPlaceholder | vtranslate }}"
                    [(ngModel)]="config.reservation"
                    configFieldInputValidation
                    objectType="QuotaConfig"
                    fieldName="reservation"
                />
            </avi-input-container>
        </div>

        <div class="full-modal-config__form-control">
            <avi-input-container
                noMarginTop
                helperText="{{ l10nKeys.licenseLimitHelperText | vtranslate }}"
            >
                <label
                    aviLabelWithTooltip
                    objectType="QuotaConfig"
                    fieldName="limit"
                    for="license-quota-limit"
                >
                    {{ l10nKeys.licenseLimitInputLabel | vtranslate }}
                </label>
                <input
                    clrInput
                    id="license-quota-limit"
                    name="license-quota-limit"
                    type="number"
                    placeholder="{{ l10nKeys.licenseLimitInputPlaceholder | vtranslate }}"
                    [(ngModel)]="config.limit"
                    configFieldInputValidation
                    objectType="QuotaConfig"
                    fieldName="limit"
                />
            </avi-input-container>
        </div>
    </div>
</div>
